<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Price.FullContainerFreightDetails')"
    width="960px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view fcl-form"
  >
    <div class="main-content">
      <div style="margin-bottom: 10px">
        <el-button no="onSubmit" type="success" @click="onSubmit">{{ $t('Pricing.Save') }}</el-button>
        <el-button no="onCancel" type="success" @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
      </div>
      <div style="width: fit-content">
        <div style="display: flex">
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item :label="$t('Pricing.PriceNo')">
                <el-input
                  no="priceNo"
                  :value="price.priceNo"
                  :disabled="true"
                />
              </el-form-item>
              <el-form-item ref="freightType" required :label="$t('Pricing.PriceType')">
                <cargo-advance-select
                  :disabled="disabledFreightType"
                  no="freightType"
                  :static-options="priceTypes"
                  tag-value="code"
                  :default-value="price.freightType"
                  :clearable="false"
                  @parentCallBack="p=>{price.freightType=p.value}"
                />
              </el-form-item>
              <el-form-item ref="pol" required :label="$t('Pricing.POL')">
                <cargo-advance-select
                  no="pol"
                  :static-options="seaPortList"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  tag-value="code"
                  :default-value="price.pol"
                  filterable
                  @parentCallBack="p=>{price.pol=p.value}"
                />
              </el-form-item>
              <el-form-item ref="pod" required :label="$t('Pricing.POD')">
                <cargo-advance-select
                  no="pod"
                  :static-options="seaPortList"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  tag-value="code"
                  :default-value="price.pod"
                  filterable
                  @parentCallBack="p=>{price.pod=p.value}"
                />
              </el-form-item>
              <el-form-item label=" ">
                <el-checkbox v-model="price.direct" no="direct" :label="$t('Pricing.Direct')" />
              </el-form-item>
              <el-form-item label=" ">
                <el-checkbox v-model="checkSaleState" no="checkSaleState" :label="$t('Pricing.SpecialPrice')" />
              </el-form-item>
              <el-form-item v-if="!price.direct" ref="via" :required="true" :label="$t('Pricing.Via')">
                <cargo-advance-select
                  no="via"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.via"
                  filterable
                  @parentCallBack="p=>{price.via=p.value}"
                />
              </el-form-item>
              <el-form-item ref="term" required :label="$t('Pricing.PaymentTerm')">
                <cargo-advance-select
                  no="term"
                  :select-type="selectTypeNames.local_cache_PriceConstant$PAYMENT_TERMS"
                  :show-custom-label-in-option="true"
                  :default-value="price.term"
                  @parentCallBack="p=>{price.term=p.value}"
                />
              </el-form-item>
              <el-form-item ref="carrier" required :label="$t('Pricing.Carrier')">
                <cargo-advance-select
                  no="carrier"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{seaCmp:true, active: true}"
                  :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
                  :show-custom-label-in-option="true"
                  :default-value="price.carrier"
                  @parentCallBack="p=>{price.carrier=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item ref="vessel" :label="$t('SeaExport.Vessel')">
                <cargo-advance-select
                  no="vessel"
                  :select-type="selectTypeNames.static_data_Vessel"
                  filterable
                  :allow-create="true"
                  :static-options="vesselList"
                  :default-value="price.vessel"
                  @parentCallBack="p=>{onVesselSelectionChange(p)}"
                />
              </el-form-item>
              <el-form-item ref="voyageFlight" :label="$t('SeaExport.Voyage')">
                <cargo-advance-select
                  ref="voyageFlight"
                  no="6"
                  :static-options="voyages || []"
                  :cache="false"
                  :default-value="price.voyageFlight"
                  filterable
                  clearable
                  :allow-create="true"
                  tag-name="voyageNo"
                  tag-value="voyageNo"
                  :filter-tag-names="['voyageNo']"
                  @parentCallBack="p=>{price.voyageFlight=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.ShippingLine')">
                <el-input
                  v-model="price.shippingLine"
                  no="shippingLine"
                  :maxlength="16"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.ContractNo')">
                <el-input
                  v-model="price.contractNo"
                  no="contractNo"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Lane')">
                <el-input
                  v-model="price.lane"
                  no="lane"
                  :maxlength="64"
                />
              </el-form-item>
              <el-form-item ref="bookingAgent" required :label="$t('Pricing.Source')">
                <cargo-advance-select
                  no="bookingAgent"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{bookingAgent:true, active: true}"
                  :custom-label="(item)=>`${item.chineseName}`"
                  :show-custom-label-in-option="true"
                  :default-value="price.bookingAgent"
                  @parentCallBack="p=>{price.bookingAgent=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.TransportMode')">
                <cargo-advance-select
                  no="transportMode"
                  filterable
                  :select-type="selectTypeNames.basic_data_ShippingTerm"
                  :placeholder="$t('Pricing.PlsSelect')"
                  :default-value="price.transportMode"
                  tag-value="name"
                  @parentCallBack="p=>{price.transportMode=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.SubContractNo')">
                <el-input
                  v-model="price.subContractNo"
                  no="subContractNo"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.NA')">
                <el-input
                  v-model="price.na"
                  no="na"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.NaCode')">
                <el-input
                  v-model="price.naCode"
                  no="naCode"
                  :maxlength="32"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item :label="$t('Pricing.COST_VAT')">
                <div style="display: flex">
                  <el-input
                    v-model="costVat"
                    no="costVat"
                    type="number"
                    style="width: 100%"
                    @change="costVatChange"
                    @focus="checkCost"
                  />
                  <label> %</label>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.SELL_VAT')">
                <div style="display: flex">
                  <el-input
                    v-model="sellVat"
                    no="sellVat"
                    type="number"
                    style="width: 100%"
                    @change="sellVatChange"
                    @focus="checkSell"
                  />
                  <label> %</label>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.Dock')">
                <el-input
                  v-model="price.dock"
                  no="dock"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.DestinationDock')">
                <el-input
                  v-model="price.destinationDock"
                  no="destinationDock"
                  :maxlength="32"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.DepartureDay')">
                <el-input
                  no="isFrequency"
                  :disabled="true"
                  :value="isFrequency"
                />
              </el-form-item>
              <el-checkbox v-model="price.frequency1" no="frequency1" :label="1" style="margin-right: 12px;" />
              <el-checkbox v-model="price.frequency2" no="frequency2" :label="2" style="margin-right: 12px;" />
              <el-checkbox v-model="price.frequency3" no="frequency3" :label="3" style="margin-right: 12px;" />
              <el-checkbox v-model="price.frequency4" no="frequency4" :label="4" style="margin-right: 12px;" />
              <el-checkbox v-model="price.frequency5" no="frequency5" :label="5" style="margin-right: 12px;" />
              <el-checkbox v-model="price.frequency6" no="frequency6" :label="6" style="margin-right: 12px;" />
              <el-checkbox v-model="price.frequency7" no="frequency7" :label="7" style="margin-right: 12px;" />
              <el-form-item :label="$t('Pricing.ClosingDay')">
                <el-input
                  no="closingDay"
                  :disabled="true"
                  :value="price.closingDay"
                />
              </el-form-item>
              <el-checkbox-group v-model="closingDay" no="closingDay">
                <el-col
                  v-for="code in frequencys"
                  :key="code"
                  style="width: 14%;"
                >
                  <el-checkbox :label="code" />
                </el-col>
              </el-checkbox-group>
              <el-form-item ref="days" :required="true" :label="$t('Pricing.DaysUnitSea')">
                <el-input-number
                  v-model="price.days"
                  no="days"
                  :min="0"
                  :controls="false"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item ref="freeTime" :required="isHc?true:false" :label="$t('Pricing.FreeTime')">
                <el-input-number
                  v-model="price.freeTime"
                  no="freeTime"
                  :precision="0"
                  :controls="false"
                  :min="0"
                  :max="999999999"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Currency')">
                <cargo-advance-select
                  no="currency"
                  filterable
                  :select-type="selectTypeNames.basic_data_Currency"
                  :clearable="false"
                  :default-value="price.currency"
                  @parentCallBack="p=>{price.currency=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.EqType')">
                <cargo-advance-select
                  no="eqType"
                  :select-type="selectTypeNames.basic_data_EQType"
                  tag-name="code"
                  :clearable="false"
                  :default-value="price.eqType"
                  @parentCallBack="p=>{price.eqType=p.value}"
                />
              </el-form-item>
              <el-form-item label="20'">
                <numeric-stepper
                  ref="cost20"
                  no="cost20"
                  :show-tact="false"
                  :show-value="price.cost20"
                  @onChangeValue="p=>{price.cost20=p}"
                />
              </el-form-item>
              <el-form-item label="40'">
                <numeric-stepper
                  ref="cost40"
                  no="cost40"
                  :show-tact="false"
                  :show-value="price.cost40"
                  @onChangeValue="p=>{price.cost40=p}"
                />
              </el-form-item>
              <el-form-item label="40HC'">
                <numeric-stepper
                  ref="costhc"
                  no="costhc"
                  :show-tact="false"
                  :show-value="price.costhc"
                  @onChangeValue="p=>{price.costhc=p}"
                />
              </el-form-item>
              <el-form-item label="20'NOR">
                <numeric-stepper
                  ref="cost20nor"
                  no="cost20nor"
                  :show-tact="false"
                  :show-value="price.cost20nor"
                  @onChangeValue="p=>{price.cost20nor=p}"
                />
              </el-form-item>
              <el-form-item label="40'NOR">
                <numeric-stepper
                  ref="cost40nor"
                  no="cost40nor"
                  :show-tact="false"
                  :show-value="price.cost40nor"
                  @onChangeValue="p=>{price.cost40nor=p}"
                />
              </el-form-item>
              <el-form-item label="45'">
                <numeric-stepper
                  ref="cost45"
                  no="cost45"
                  :show-tact="false"
                  :show-value="price.cost45"
                  @onChangeValue="p=>{price.cost45=p}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.priceNature')">
                <cargo-advance-select
                  no="priceNature"
                  :select-type="selectTypeNames.local_cache_PriceConstant$PRICE_NATURE"
                  :show-custom-label-in-option="true"
                  :default-value="price.priceNature"
                  @parentCallBack="p=>{price.priceNature=p.value}"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item :label="$t('Pricing.CabinNature')">
                <cargo-advance-select
                  no="share"
                  :select-type="selectTypeNames.local_cache_PriceConstant$CABIN_NATURE"
                  :show-custom-label-in-option="true"
                  :default-value="price.share"
                  @parentCallBack="p=>{price.share=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.SaleState')">
                <cargo-advance-select
                  no="saleState"
                  :select-type="selectTypeNames.local_cache_SpecialPriceSaleState$SALE_STATE_TYPES"
                  :show-custom-label-in-option="true"
                  :default-value="price.saleState"
                  :clearable="false"
                  @parentCallBack="p=>{price.saleState=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.PriceState')">
                <cargo-advance-select
                  no="priceState"
                  :select-type="selectTypeNames.local_cache_PriceConstant$PRICE_STATE"
                  :show-custom-label-in-option="true"
                  :default-value="price.priceState"
                  :clearable="false"
                  @parentCallBack="p=>{price.priceState=p.value}"
                />
              </el-form-item>
              <el-form-item v-if="price.priceState === 2" :label="$t('Pricing.PriceState_Reject')">
                <div style="display: flex">
                  <el-checkbox v-model="price.reject20" no="reject20" label="20'" style="margin-right: 8px" />
                  <el-checkbox v-model="price.reject40" no="reject40" label="40'" style="margin-right: 8px" />
                  <el-checkbox v-model="price.rejectHC" no="rejectHC" label="40'HC" style="margin-right: 8px" />
                  <el-checkbox v-model="price.reject45" no="reject45" label="45'" style="margin-right: 8px" />
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CargoType')">
                <cargo-advance-select
                  no="cargoType"
                  filterable
                  :clearable="false"
                  :select-type="selectTypeNames.basic_data_CargoType"
                  :default-value="price.cargoType"
                  @parentCallBack="p=>{price.cargoType=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Commodity')">
                <el-input v-model="price.commodity" no="commodity" type="textarea" />
              </el-form-item>
              <el-form-item :label="$t('Pricing.ServiceMode')">
                <cargo-advance-select
                  no="serviceMode"
                  :select-type="selectTypeNames.local_cache_PriceConstant$SERVICE_MODES"
                  :placeholder="$t('Price.EuropeAndAmericaLinesDedicated')"
                  :show-custom-label-in-option="true"
                  :default-value="price.serviceMode"
                  :clearable="false"
                  @parentCallBack="p=>{price.serviceMode=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.ServiceCode')">
                <el-input
                  v-model="price.serviceCode"
                  no="serviceCode"
                  :placeholder="$t('Price.EuropeAndAmericaLinesDedicated')"
                  :maxlength="255"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.PriceTrend')">
                <el-radio-group v-model="price.trend" no="trend" style="display: flex; margin-top: 3px">
                  <el-radio no="rise" :label="1">{{ $t('Pricing.Rise') }}</el-radio>
                  <el-radio no="fair" :label="0">{{ $t('Pricing.Fair') }}</el-radio>
                  <el-radio no="fall" :label="-1">{{ $t('Pricing.Fall') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item ref="etd" :required="isHc || (!isHc && price && price.freightType === 1)?true:false" :label="$t('Pricing.ECommerceEtd')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.etd"
                    no="etd"
                    class="departure-date-picker"
                    type="date"
                    style="flex: 1;"
                    value-format="yyyy-MM-dd"
                  />
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.ECommerceEta')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.eta"
                    no="eta"
                    type="date"
                    style="flex: 1;"
                    value-format="yyyy-MM-dd"
                  />
                </div>
              </el-form-item>
              <el-form-item ref="beginDate" required :label="$t('Pricing.BeginDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.beginDate"
                    no="beginDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="{
                      disabledDate: time => {
                        return price.endDate && time.getTime() >= new Date(price.endDate.length <= 10 ? price.endDate + ' 00:00:00' : price.endDate).getTime()
                      }
                    }"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item ref="endDate" required :label="$t('Pricing.EndDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.endDate"
                    no="endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="{
                      disabledDate: time => {
                        return price.beginDate && time.getTime() <= new Date(price.beginDate.length <= 10 ? price.beginDate + ' 00:00:00' : price.beginDate).getTime()
                      }
                    }"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.EffectiveDateType')">
                <cargo-advance-select
                  no="dateTypeEffective"
                  :select-type="selectTypeNames.local_cache_PriceFclDataType$PRC_DATE_TYPE"
                  :show-custom-label-in-option="true"
                  :clearable="false"
                  :default-value="price.dateTypeEffective"
                  @parentCallBack="p=>{price.dateTypeEffective=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.ExpirationDateType')">
                <cargo-advance-select
                  no="dateTypeExpiration"
                  :select-type="selectTypeNames.local_cache_PriceFclDataType$PRC_DATE_TYPE"
                  :show-custom-label-in-option="true"
                  :clearable="false"
                  :default-value="price.dateTypeExpiration"
                  @parentCallBack="p=>{price.dateTypeExpiration=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.ReceivingInstructions')">
                <el-input v-model="price.receivingInstructions" no="receivingInstructions" type="textarea" />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Remarks')">
                <cargo-rich-textarea
                  v-model="price.remarks"
                  no="remarks"
                  :text-chars="0"
                  style="min-height: 80px"
                  :warning-count="-1"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),price.remarks,val=>{price.remarks=val})"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialog"
        :disabled="readonly"
        :required="false"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        style="height: 198px;"
      />
      <span slot="footer">
        <el-button
          v-show="!readonly"
          no="finishAdvanceText"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="close"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { TenantUtil } from '@/class/cargo/model/utils/TenantUtil'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import NumericStepper from '@/views/cargo/v0/Price/components/numericStepper'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import { savePriceFcl } from '@/api/price/priceFcl'
import * as commonUtil from '@/utils/commonUtil'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { Voyage } from '@/class/model/mdm/Voyage'
import { loadSpecificBasicInfo } from '@/api/cache'
import { cacheName, cache } from '@/utils/cacheManager'

export default {
  name: 'FclForm',
  components: { CargoAgGrid, cargoAdvanceSelect, NumericStepper,
    cargoRichTextarea },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    isNew: {
      type: Boolean,
      default: () => false
    },
    sourcePrice: { // 原数据值，回显用
      type: Object,
      default: () => ({})
    },
    price: { // 复制出来的值
      type: Object,
      default: () => ({})
    },
    disabledFreightType: { type: Boolean, default: false },
    isCp: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      frequencys: PriceUtils.FREQUENCYS,
      priceTypes: PriceConstant.PRICE_TYPES,
      costVat: null,
      sellVat: null,
      seaPortList: [],
      vesselList: [],
      voyages: [],
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0
        }
      },
      isHc: false // 是否合创
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    closingDay: {
      get() {
        return StrUtils.isEmpty(this.price.closingDay) ? [] : this.price.closingDay.split(',')
      },
      set(val) {
        this.price.closingDay = val.join(',')
      }
    },
    checkSaleState: {
      get() {
        return this.price.saleState === 1
      },
      set(val) {
        this.price.saleState = val ? 1 : 0
      }
    },
    isFrequency() {
      const FREQUENCYS = PriceUtils.FREQUENCYS
      const arr = []
      for (const field of FREQUENCYS) {
        if (this.price['frequency' + field]) {
          arr.push(field)
        }
      }
      return arr.join('/')
    },
    isZh() {
      return this.$store.getters.language
    }
  },
  watch: {
  },
  created() {
    this.closingDay = StrUtils.isEmpty(this.price.closingDay) ? [] : this.price.closingDay.split(',')
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.tenantUtil = await TenantUtil.getInstance()
      this.sellVatChange(this.price.sellVat)
      this.costVatChange(this.price.costVat)
      this.setSeaportList()
      this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
      const currentVessel = this.vesselList.filter(p => p.englishName === this.price.vessel)[0]
      if (currentVessel) {
        await this.getVoyageByVessel(currentVessel)
      }
      await cache.load(cacheName.CONFIG)
      this.isHc = String(cache.config.get('ToExoSystem')) === 'HC'
    },
    onSubmit() {
      this.price['frequency8'] = this.isFrequency
      if (this.verifyForm()) {
        return
      }
      if (this.verifySame('pol', 'pod')) {
        return
      }
      // SPOT运价时，校验字段是否填写
      if (this.price.freightType === 1) {
        const checkFields = ['etd']
        for (const checkField of checkFields) {
          if (this.verifyField(checkField)) {
            const label = this.$refs[checkField].label
            this.$message.warning(label + this.$t('Pricing.WrongInput'))
            return
          }
        }
      }
      if (this.price.etd && this.price.eta) { // 将日期字符串转换为日期对象
        const etd = new Date(this.price.etd)
        const eta = new Date(this.price.eta) // 比较两个日期对象的大小
        if (etd > eta) { // 如果 price.eta 时间早于 price.etd，则提示错误信息
          this.$message.warning(this.$t('Pricing.EtaMustBeLaterThanOrEqualToEtd'))
          return
        }
      }
      if (!this.price.direct) {
        if (!StrUtils.isEmpty(this.price.via)) {
          if (this.verifySame('via', 'pol')) {
            return
          }
          if (this.verifySame('via', 'pod')) {
            return
          }
        } else {
          const label = this.$refs['via'].label
          this.$message.warning(label + this.$t('Pricing.WrongInput'))
          return
        }
      } else {
        this.price.via = ''
      }
      if (this.price.sellVat < this.price.costVat) {
        this.$message.warning(this.$t('Pricing.VatInvalid'))
        return
      }
      if (this.price.days !== 0 && StrUtils.isEmpty(this.price.days)) {
        this.$message.warning(this.$t('Pricing.DaysValidate'))
        return
      }
      if (this.price.priceState !== 2) {
        this.price.reject20 = false
        this.price.reject40 = false
        this.price.rejectHC = false
        this.price.reject45 = false
      }
      if (this.price.beginDate > this.price.endDate) {
        this.$message.warning(this.$t('Pricing.CompareValidate'))
        return
      }
      if (this.price.closingDay.length > 0 && this.price.closingDay.length !== this.isFrequency.length) {
        const message = this.$t('Pricing.NotSameLength')
        const closingDay = this.$t('Pricing.ClosingDay')
        const departureDay = this.$t('Pricing.DepartureDay')
        this.$message.warning(message.replace('{0}', closingDay).replace('{1}', departureDay))
        return
      }
      this.price.receivingType = StrUtils.isEmpty(this.price.receivingInstructions) ? 0 : 1
      this.price.modifiedBy = this.$store.getters.userId
      this.price.dateModified = new Date()
      this.price.branchId = this.$store.getters.currentOfficeId
      this.setDefaultValue('customSpecs', 'via', 'serviceMode', 'commodity', 'serviceCode', 'lane', 'dock')
      this.save()
    },
    save() {
      if (this.price.state === 1) {
        this.price.state = 0
        this.price.active = false
        this.price.dateEffective = null
        this.price.dateApproved = null
        this.price.approvedBy = 0
        this.price.priceNo = ''
        this.price.one20 = PriceConstant.NIL
        this.price.one40 = PriceConstant.NIL
        this.price.oneHC = PriceConstant.NIL
        this.price.one45 = PriceConstant.NIL
        this.price.two20 = PriceConstant.NIL
        this.price.two40 = PriceConstant.NIL
        this.price.twoHC = PriceConstant.NIL
        this.price.two45 = PriceConstant.NIL
        this.price.three20 = PriceConstant.NIL
        this.price.three40 = PriceConstant.NIL
        this.price.threeHC = PriceConstant.NIL
        this.price.three45 = PriceConstant.NIL
        this.deleteCp(this.sourcePrice)
      }
      savePriceFcl(this.price).then((res) => {
        commonUtil.objCopy(res.data, this.sourcePrice)
        if (this.isNew) {
          this.$message.success(this.$t('Pricing.SavedSucceed'))
        } else {
          if (this.isCp) {
            this.$message.success(this.$t('Pricing.CurrentPriceEditSucceed'))
          } else {
            this.$message.success(this.$t('Pricing.SavedSucceed'))
          }
        }
        this.$emit('clearGrid')
        this.$emit('close')
        // this.$emit('reload')
      })
    },
    // 修改已发布运价后, 移除原有记录
    deleteCp(data) {
      const params = []
      params.push(data.uuid)
      this.$emit('deleteCp', params)
    },
    setDefaultValue(...fields) {
      fields.forEach(item => {
        if (!this.price[item]) {
          this.price[item] = ''
        }
      })
    },
    verifyForm() {
      for (const ref in this.$refs) {
        if (ref === 'via') {
          continue
        }
        if (this.$refs[ref].isRequired && this.verifyField(ref)) {
          const label = this.$refs[ref].label
          this.$message.warning(label + this.$t('Pricing.WrongInput'))
          return true
        }
      }
    },
    verifyField(field) {
      if (typeof this.price[field] === 'number') {
        return this.price[field] === 0 && field !== 'freightType'
      }
      return StrUtils.isEmpty(this.price[field])
    },
    verifySame(field1, field2) {
      if (this.price[field1] === this.price[field2]) {
        const label1 = this.$refs[field1].label
        const label2 = this.$refs[field2].label
        const message = this.$t('Pricing.MustDifferent')
        this.$message.warning(message.replace('{0}', label1).replace('{1}', label2))
        return true
      }
      return false
    },
    onCancel() {
      this.$emit('close')
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    costVatChange(newVal) {
      const val = Number(newVal)
      /* if (!val || val < 0) {
        this.costVat = null
        this.price.costVat = 0
        return
      } */
      const formatNumber = this.$numeral(val).format('0.000')
      this.price.costVat = formatNumber
      this.costVat = formatNumber
    },
    checkCost(newVal) {
      if (newVal === '-') {
        this.costVat = ''
        return
      }
    },
    checkSell(newVal) {
      if (newVal === '-') {
        this.sellVat = ''
        return
      }
    },
    sellVatChange(newVal) {
      const val = Number(newVal)
      /* if (!val || val < 0) {
      this.sellVat = null
      this.price.sellVat = 0
      return
      } */
      const formatNumber = this.$numeral(val).format('0.000')
      this.price.sellVat = formatNumber
      this.sellVat = formatNumber
    },
    setSeaportList() {
      getSpecificBasicData(basicCacheKeys.basic_data_Seaport).then(res => {
        this.seaPortList = res
      })
    },
    /**
     * vessel change
     */
    onVesselSelectionChange(data) {
      this.price.vessel = data.value
      this.getVoyageByVessel(data)
    },
    async getVoyageByVessel(data) {
      if (data.vesselId) {
        this.voyages = await Voyage.getVoyage(data.vesselId)
      } else {
        this.voyages = []
      }
    }
  }
}
</script>

<style lang="scss">
  .fcl-form{
    .el-radio{
      margin-right: 20px;
    }
  }
</style>
